// src/components/PriorityBadge.jsx
const CONFIG = {
  1: { label: 'P1 · Emergency', bg: 'bg-p1-100', text: 'text-p1', edge: 'bg-p1' },
  2: { label: 'P2 · Urgent', bg: 'bg-p2-100', text: 'text-p2', edge: 'bg-p2' },
  3: { label: 'P3 · Standard', bg: 'bg-p3-100', text: 'text-p3', edge: 'bg-p3' },
};

export function priorityConfig(priority) {
  return CONFIG[priority] ?? { label: 'Unclassified', bg: 'bg-gray-100', text: 'text-gray-500', edge: 'bg-gray-300' };
}

export default function PriorityBadge({ priority }) {
  const c = priorityConfig(priority);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${c.bg} ${c.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.edge} ${priority === 1 ? 'animate-p1-pulse' : ''}`} />
      {c.label}
    </span>
  );
}
